// --- Our Modules --------------------------------------------------------------------------------
import useLang from "@/hooks/useLang";
import type { Lang } from "@/hooks/useLang/types";
import useTranslation from "@/hooks/useTranslation";
import OutlinedField from "@/UI/components/OutlinedField";
import SettingsCard from "@/UI/components/SettingsCard";
import "./styles.css";

// --- Logic --------------------------------------------------------------------------------------

export default function SettingsPreferences() {
    const t = useTranslation();
    const lang = useLang((state) => state.lang);
    const setLang = useLang((state) => state.setLang);

    const languages: Array<{ value: Lang; label: string }> = [
        { value: "ar", label: t.settings.languageArabic },
        { value: "en", label: t.settings.languageEnglish },
    ];

    return (
        // Both controls are local to this browser, so they apply on click — there is nothing to save.
        <SettingsCard icon="/icons/settings-icon.svg" title={t.settings.preferencesTitle} subtitle={t.settings.preferencesSubtitle}>
            <div className="settings-field">
                <OutlinedField label={t.settings.languageLabel}>
                    <div className="settings-choice">
                        {languages.map((option) => (
                            <button
                                key={option.value}
                                type="button"
                                className="settings-choice-option"
                                aria-pressed={(lang ?? "ar") === option.value}
                                onClick={() => setLang(option.value)}
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                </OutlinedField>
            </div>

            <div className="settings-field">
                <OutlinedField label={t.settings.themeLabel} badge={t.settings.comingSoon}>
                    <div className="settings-choice settings-choice--locked">
                        <button type="button" className="settings-choice-option" aria-pressed={true} disabled>
                            {t.settings.themeLight}
                        </button>
                        <button type="button" className="settings-choice-option" aria-pressed={false} disabled>
                            {t.settings.themeDark}
                        </button>
                    </div>
                </OutlinedField>
                <p className="settings-field-hint">{t.settings.themeHint}</p>
            </div>
        </SettingsCard>
    );
}
